module.exports = __webpack_public_path__ + "img/boat-3.53a6fde3.jpg";